"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var h = require("./../../utils/createElement").h;
var React = tslib_1.__importStar(require("react"));
var PropTypes = tslib_1.__importStar(require("prop-types"));
var helper_1 = require("../../utils/helper");
var context_1 = require("../Form/context");
var theme_1 = require("../../utils/theme");
var Input = (function (_super) {
    tslib_1.__extends(Input, _super);
    function Input() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.leftIconRef = React.createRef();
        _this.rightIconsRef = React.createRef();
        _this.state = {
            value: _this.props.defaultValue,
        };
        _this.handleChange = function (e) {
            if (_this.props.disabled) {
                return;
            }
            var value = e.target.value;
            _this.props.onChange(value, e);
            _this.setState({ value: value });
        };
        _this.preventLoseFocus = function (e) {
            e.preventDefault();
        };
        _this.handleClear = function () {
            _this.setState({ value: '' }, function () {
                _this.props.onChange('');
            });
        };
        _this.themedRender = function (classNames) {
            var _a;
            var _b = _this.props, prefixCls = _b.prefixCls, className = _b.className, style = _b.style, disabled = _b.disabled, underline = _b.underline, icon = _b.icon, leftIcon = _b.leftIcon, onClickIcon = _b.onClickIcon, onClickLeftIcon = _b.onClickLeftIcon, onChange = _b.onChange, inputStyle = _b.inputStyle, showClear = _b.showClear, forcedValue = _b.value, defaultValue = _b.defaultValue, inputRef = _b.inputRef, rest = tslib_1.__rest(_b, ["prefixCls", "className", "style", "disabled", "underline", "icon", "leftIcon", "onClickIcon", "onClickLeftIcon", "onChange", "inputStyle", "showClear", "value", "defaultValue", "inputRef"]);
            var stateValue = _this.state.value;
            var status = _this.context.status;
            var value = typeof forcedValue === 'string' ? forcedValue : stateValue;
            var classes = classNames(prefixCls, className, (_a = {},
                _a[prefixCls + "-disabled"] = disabled,
                _a));
            var inputClasses = classNames(prefixCls + "-input", prefixCls + "-input-" + status, prefixCls + "-input-" + (underline ? 'underline' : 'normal'));
            var indicatorClasses = classNames(prefixCls + "-indicator", prefixCls + "-indicator-" + status);
            var clearVisible = !!(value && !disabled);
            return (h("div", { className: classes, style: style },
                _this.renderSingleIcon(classNames, {
                    prop: leftIcon,
                    description: 'left',
                    handler: onClickLeftIcon,
                    ref: _this.leftIconRef
                }),
                h("input", tslib_1.__assign({ className: inputClasses, style: tslib_1.__assign(tslib_1.__assign({}, _this.getIconPaddings()), inputStyle), onChange: _this.handleChange, value: value, disabled: disabled, ref: inputRef }, rest)),
                underline ?
                    h("span", { className: indicatorClasses })
                    : null,
                _this.renderRightIcons(classNames, clearVisible)));
        };
        return _this;
    }
    Input.prototype.componentDidMount = function () {
        this.forceUpdate();
    };
    Input.prototype.getIconPaddings = function () {
        var leftIconDom = this.leftIconRef.current;
        var rightIconsDom = this.rightIconsRef.current;
        var result = {};
        var gap = 2;
        if (leftIconDom) {
            result.paddingLeft = leftIconDom.getBoundingClientRect().width + gap + "px";
        }
        if (rightIconsDom) {
            result.paddingRight = rightIconsDom.getBoundingClientRect().width + gap + "px";
        }
        return result;
    };
    Input.prototype.renderSingleIcon = function (classNames, _a) {
        var _b;
        var prop = _a.prop, description = _a.description, handler = _a.handler, ref = _a.ref;
        var _c = this.props, prefixCls = _c.prefixCls, underline = _c.underline;
        var classes = classNames(prefixCls + "-icon", (_b = {},
            _b[prefixCls + "-icon-" + description] = description,
            _b[prefixCls + "-icon-clickable"] = handler,
            _b[prefixCls + "-icon-underline"] = underline,
            _b));
        return prop ?
            h("div", { className: classes, onMouseDown: this.preventLoseFocus, onClick: handler, ref: ref }, typeof prop === 'string' ?
                h("span", { className: classNames(prefixCls + "-icon-img"), style: { backgroundImage: "url(" + prop + ")" } })
                : prop)
            : null;
    };
    Input.prototype.renderRightIcons = function (classNames, clearVisible) {
        var _a, _b;
        var _c = this.props, prefixCls = _c.prefixCls, showClear = _c.showClear, icon = _c.icon, onClickIcon = _c.onClickIcon, underline = _c.underline;
        var clearClasses = classNames(prefixCls + "-clear", prefixCls + "-icon-clickable", (_a = {},
            _a[prefixCls + "-clear-visible"] = clearVisible,
            _a[prefixCls + "-icon"] = !underline,
            _a[prefixCls + "-clear-underline"] = underline,
            _a));
        var containerClasses = classNames(prefixCls + "-icon-container", (_b = {},
            _b[prefixCls + "-icon-container-underline"] = underline,
            _b));
        return (showClear || icon) ?
            h("div", { className: containerClasses, ref: this.rightIconsRef },
                showClear ?
                    h("span", { className: clearClasses, onMouseDown: this.preventLoseFocus, onClick: this.handleClear })
                    : null,
                this.renderSingleIcon(classNames, {
                    prop: icon,
                    handler: onClickIcon
                }))
            : null;
    };
    Input.prototype.render = function () {
        return theme_1.consumeTheme(this.themedRender);
    };
    Input.contextType = context_1.FormItemContext;
    return Input;
}(React.Component));
exports.default = Input;
Input.defaultProps = {
    prefixCls: 'dui-m-input',
    onChange: helper_1.emptyFn,
    showClear: false,
    defaultValue: ''
};
Input.propTypes = {
    prefixCls: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    underline: PropTypes.bool,
    icon: PropTypes.node,
    onClickIcon: PropTypes.func,
    leftIcon: PropTypes.node,
    onClickLeftIcon: PropTypes.func,
    inputStyle: PropTypes.object,
    showClear: PropTypes.bool,
    value: PropTypes.string,
    defaultValue: PropTypes.string,
};
